export default {
  settings: {
    viewTitle: "Setting",
    tabTitle: "Setting",
    button: {
      create: "NEW USER",
      edit: "EDIT",
    },
    notify: {
      success: {
        save: "ユーザーの保存に成功しました",
      },
      error: {
        failedSave: "ユーザーの保存に失敗しました",
      },
    },
    tableHeader: {
      name: "ユーザー名",
      email: "メールアドレス",
      userType: "権限",
    },
    tooltip: {
      pageInformation: "ログイン中のユーザーは常に先頭に表示されます",
      passwordSyntax: {
        type: "半角英数のみ",
        required: "大文字,小文字,数字が必須",
        limit: "8~32文字",
      },
    },
    text: {
      userDialog: {
        createTitle: "新規ユーザー作成",
        updateTitle: "ユーザー編集",
        email: "メールアドレス",
        password: "パスワード",
        confirmPassword: "確認用パスワード",
        userName: "ユーザー名",
        userType: "権限",
        publisher: "パブリッシャー",
        searchPublisher: "パブリッシャーを検索",
        adminPublisher: "このユーザーはすべてのパブリッシャーが選択されます",
      },
      searchUser: "ユーザーを検索",
    },
  },
};
